import https, { downloadExcel } from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { ContentType, Method } from 'axios-mapper'
import {
  AvailableAcceptanceModel,
  AvailableAcceptancePageModel, AvailableAcceptancePageParamModel
} from '@/model/accepted-bill/availableAcceptanceModel'

const baseUrl = '/base/payment/slip/acceptance/available'

export const getAvailableAcceptancePageList = (params: AvailableAcceptancePageParamModel) => {
  return https()
    .request<RootObject<AvailableAcceptancePageModel>>(baseUrl + '/list/page', Method.POST, params, ContentType.json)
}

export const getAvailableAcceptanceDetails = (id: number) => {
  return https()
    .request<RootObject<AvailableAcceptanceModel>>(baseUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const exportAvailableAcceptance = (params: AvailableAcceptancePageParamModel): Promise<string | null> => {
  return downloadExcel(baseUrl + '/list/export', Method.POST, params)
}
